import script from "./creator-profile-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./creator-profile-edit.vue?vue&type=script&setup=true&lang=js"

import "./creator-profile-edit.vue?vue&type=style&index=0&id=05ffaf0e&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ffaf0e"]])

export default __exports__